import React from 'react';
import { useParams } from 'react-router-dom';
import { type TrevorComponent, TrevorIcon } from '@trevor/ui-components';
import { SavedQuery } from '@/types';
import { unifiedStopPropagation } from '@/util/unifiedStopPropagation';
import {
  StepValue,
  StepValueAction,
} from '@/views/QueryBuilder/subcomponents/Steps';

export type SavedQueryLabel = {
  name: SavedQuery['name'];
  series: SavedQuery['series'];
  onClick?: F<React.MouseEvent>;
};

export const SavedQueryLabel: TrevorComponent<SavedQueryLabel> = ({
  name,
  series,
  onClick,
}) => {
  const { datasourceId } = useParams();

  const handleRedirectToQuery = (e: React.MouseEvent) => {
    unifiedStopPropagation(e);
    window.open(
      `/datasources/${datasourceId}/saved-queries/${series}`,
      '_blank',
    );
  };
  return (
    <StepValue $type="start" isSavedQuery onClick={onClick}>
      {name}
      <StepValueAction onClick={handleRedirectToQuery}>
        <TrevorIcon name="export" />
      </StepValueAction>
    </StepValue>
  );
};
